<a
  *ngIf="href$ | async as href"
  class="new-portal-link"
  data-testid="new-portal-link"
  [href]="href"
>
  <mat-list-item fxLayout="row" fxLayoutAlign="start center">
    <mat-icon>open_in_new</mat-icon>
    <h3 class="sb-nav-header">{{ (text$ | async)?.TryTheNewPortal }}</h3>
  </mat-list-item>
</a>
